<template>
  <div class="category">
    <div class="category-image">
      <CustomIcon v-if="image" :name="image" className="" />
    </div>
    <div class="category-content">
      <h2 v-if="title" class="category-title">{{ title }}</h2>
      <p v-if="description" class="category-description">{{ description }}</p>
    </div>
  </div>
</template>

<script>
import CustomIcon from "./CustomIcon.vue";

export default {
  name: "program-category",
  components: {
    CustomIcon,
  },
  props: {
    image: {
      type: String,
      required: false,
      default: () => String,
    },
    title: {
      type: String,
      required: false,
      default: () => String,
    },
    description: {
      type: String,
      required: false,
      default: () => String,
    },
  },
};
</script>
